import React, { useRef } from 'react'
import { Box, Text, Heading } from 'grommet'
import FlagFill from '../../icon/flagFill'
import styled, { keyframes } from 'styled-components'
import IconResult from './IconResult'
import LabelIcon from './labelIcon'
import { device } from '../../theme/device'
import { getTextColor } from '../../utils/getTextColor'
import { capitalize } from '../../utils'

const Container = styled(Box)`
  background-color: ${props => props.groupColor};
  border: 2px solid ${props => props.groupColor};
  border-radius: 1.5rem;
  height: 20rem;
  width: calc((100% - 3rem - 4rem) / 2 + 1.25rem);
  max-width: 20rem;
  min-width: 16.75rem;
  padding: 1rem 0rem 0rem;
  margin-bottom: 2rem;
  @media ${device.mobileView} {
    width: 100%;
    min-width: 100%;
  }
  overflow: hidden;
`

const GroupBox = styled(Box)`
  flex: 1;
  background-color: ${props => props.theme.global.colors.baseBackground};
  border-radius: 5px;
  padding-bottom: 0.5rem;
  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.global.colors.scrollThumb} !important;
    border-radius: 3px;
  }
`
const TextNumGroup = styled(Text)`
  line-height: 1.5rem;
`
const TextGroup = styled(Text)`
  flex: 1;
  /* line-height: 1.8rem; */
`

const Title = styled(Heading)`
  color: ${props => props.color};
  margin: 0;
`

const fadeIn = keyframes`
  0% {
    opacity: 0;
    top: 100px;
  }
  75% {
    opacity: 0.5;
    top: 0px;
  }
  100% {
    opacity: 1;
  }
`

const NameBox = styled(Box)`
  position: relative;
  animation: ${fadeIn} ${props => props.duration} linear;
  animation-fill-mode: both;
  animation-delay: ${props => `${props.delay}s`};
`

const Group = ({
  teamNum,
  members,
  groupColor,
  groupName,
  evenSplit,
  showIcon,
  isToolSpinning,
  representativeIndex,
  groupingDuration,
}) => {
  const sequences = useRef([])
  // const timeScale = useRef(0.5)
  const textColor = getTextColor(groupColor)
  let IconPattern = null
  if (evenSplit === 'Gender') {
    IconPattern = IconResult
  } else if (evenSplit === 'Label') {
    IconPattern = LabelIcon
  }

  if (sequences.current.length === 0 && members.length > 0) {
    // timeScale.current = Math.random() * (0.8 - 0.3) + 0.3
    sequences.current = Array(members.length)
      .fill(1)
      .map((_, i) => i)
      .sort((a, b) => 0.5 - Math.random())
  } else if (members.length === 0 && sequences.current.length > 0) {
    // timeScale.current = 0
    sequences.current = []
  }

  return (
    <Container gap="1rem" groupColor={groupColor}>
      <Box
        direction="row"
        justify="between"
        align="center"
        pad={{ horizontal: '1rem' }}
      >
        <Title level={5} color={textColor}>
          {groupName ? groupName : `Team ${teamNum}`}
        </Title>
        {members.length > 0 && (
          <Box
            round=".5rem"
            align="center"
            justify="center"
            height="2.2rem"
            width="2.2rem"
            border={{
              color: textColor,
              size: '1px',
              style: 'solid',
              side: 'all',
            }}
          >
            <TextNumGroup size="1.5rem" color={textColor}>
              {members.length}
            </TextNumGroup>
          </Box>
        )}
      </Box>

      <GroupBox
        overflow={{ horizontal: 'hidden', vertical: 'auto' }}
        gap=".4rem"
        pad={{ top: '.5rem' }}
      >
        {members.map((member, index) => {
          let iconName = ''
          if (evenSplit === 'Gender') {
            iconName = `${capitalize(member.gender)}Icon`
          } else if (evenSplit === 'Label') {
            iconName = member.label || 'A'
          }
          //5.0 is spin time equal to 5 seconds
          const delay =
            (isToolSpinning ? 1 : 0) *
            ((groupingDuration * 1.0) / members.length) *
            sequences.current[index]

          const representor = representativeIndex === index
          return (
            <NameBox
              direction="row"
              gap=".5rem"
              align="center"
              flex={false}
              pad={{ horizontal: '.7rem' }}
              margin={{ horizontal: '.3rem' }}
              key={`T${teamNum}${index}`}
              delay={delay}
              duration={isToolSpinning ? '0.5s' : '0s'}
              background={representor ? groupColor : 'transparent'}
            >
              {!!IconPattern && showIcon && (
                <IconPattern
                  size="1.8rem"
                  name={iconName}
                  color={representor ? textColor : 'text'}
                />
              )}
              <TextGroup color={representor ? textColor : 'text'}>
                {member.name}
              </TextGroup>
              {representor && <FlagFill color={textColor} />}
            </NameBox>
          )
        })}
      </GroupBox>
    </Container>
  )
}

export default Group
